<template>
	<div class="user-edit">
		<!-- upload-img -->
		<div class="upload-image m-b-md">
			<div class="col-xs-12 col-sm-2">
				<div class="profile-img">
					<img
						@error="setDefaultAvatar('#edit-user-photo')"
						id="edit-user-photo"
						:src="photo || '/images/users/avatar.png'"
						alt="User Photo"
					>
				</div>
			</div>
			<div class="form-group col-xs-12 col-sm-6" style="margin-top: 5px">
				<div class="field-title">
					<input
						@change="loadPhoto"
						class="form-control"
						type="file"
						name="attachment"
						id="attachment"
						placeholder=""
						accept="image/*"
						v-validate="'image|size:2048'"
						:class="{ input: true, 'is-danger': errors.has('attachment') }"
					>
					<span v-show="errors.has('attachment')" class="help is-danger">{{
						errors.first("attachment")
					}}</span>
				</div>
			</div>
			<div class="clearfix"/>
		</div>
		<!-- /.upload-img -->
		<div class="update-fields text-white">
			<div class="col-xs-12 col-sm-6">
				<div class="form-group">
					<div class="field">
						<label for="user-name">Username</label>
						<input
							v-model.trim="username"
							class="form-control"
							type="text"
							minlength="1"
							id="user-name"
							placeholder=""
							name="username"
							v-validate="'required'"
							:class="{ input: true, 'is-danger': errors.has('username') }"
						>
						<span v-show="errors.has('username')" class="help is-danger">{{
							errors.first("username")
						}}</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<label for="user-email">Email</label>

						<!-- Fake email field to avoid Chrome autofill -->
						<input style="display: none;" name="email" type="email" >

						<input
							v-model.trim="email"
							required
							v-validate="'required|email'"
							data-vv-validate-on="change"
							:class="{ input: true, 'is-danger': errors.has('email') }"
							class="form-control"
							name="email"
							type="email"
							id="user-email"
							placeholder="user@example.com"
						>
						<span v-show="errors.has('email')" class="help is-danger">{{
							errors.first("email")
						}}</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<label>Birth Date</label>

						<select
							v-model.number="birthDate.month"
							v-validate="{
								required:
									Number.isInteger(birthDate.day) ||
									Number.isInteger(birthDate.year)
							}"
							class="form-control birth-month"
							name="month"
						>
							<option value="" disabled>Month</option>
							<option value="1">January</option>
							<option value="2">February</option>
							<option value="3">March</option>
							<option value="4">April</option>
							<option value="5">May</option>
							<option value="6">June</option>
							<option value="7">July</option>
							<option value="8">August</option>
							<option value="9">September</option>
							<option value="10">October</option>
							<option value="11">November</option>
							<option value="12">December</option>
						</select>
						<span v-show="errors.has('month')" class="help is-danger">
							{{ errors.first("month") }}
						</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<select
							v-model="birthDate.day"
							v-validate="{
								required:
									Number.isInteger(birthDate.month) ||
									Number.isInteger(birthDate.year)
							}"
							class="form-control birth-day"
							name="day"
						>
							<option value="" disabled>Day</option>
							<option v-for="day in 31" :value="day" :key="day">
								{{
									day
								}}
							</option>
						</select>
						<span v-show="errors.has('day')" class="help is-danger">
							{{ errors.first("day") }}
						</span>
					</div>
				</div>

				<div class="form-group">
					<div class="field">
						<select
							v-model="birthDate.year"
							v-validate="{
								required:
									Number.isInteger(birthDate.month) ||
									Number.isInteger(birthDate.day)
							}"
							class="form-control birth-year"
							name="year"
						>
							<option value="" disabled>Year</option>
							<option v-for="year in yearList" :value="year" :key="year">
								{{
									year
								}}
							</option>
						</select>
						<span v-show="errors.has('year')" class="help is-danger">
							{{ errors.first("year") }}
						</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<label for="location">Location</label>
						<select
							v-model="location"
							class="form-control location"
							name="location"
							id="location"
						>
							<option value="" disabled>Location</option>
							<option
								v-for="(name, code) in countries"
								:value="code"
								:key="code"
							>
								{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-sm-6">
				<div class="form-group">
					<p class="text-sm">
						To update your password, please first enter your current password,
						and then enter your new password and confirm your new password.
					</p>
					<div class="field">
						<label for="current-password">Current Password</label>
						<input
							v-model="password.currentPassword"
							class="form-control"
							type="password"
							name="current_password"
							v-validate="
								`${
									password.newPassword || password.confirmPassword
										? 'required'
										: ''
								}`
							"
							data-vv-validate-on="change"
							data-vv-as="current password"
							id="current-password"
						>
						<span
							v-show="errors.has('current-password')"
							class="help is-danger"
						>
							{{ errors.first("current-password") }}
						</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<!-- Fake password field to avoid Chrome autofill -->
						<input style="display: none;" name="email" type="email" >

						<label for="new-password">New Password</label>
						<input
							v-model="password.newPassword"
							type="password"
							id="new-password"
							name="new-password"
							v-validate="{
								required: !!password.currentPassword,
								regex: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{6,}/
							}"
							data-vv-as="new password"
							data-vv-validate-on="change"
							ref="new-password"
							class="form-control input-group js-input-password"
						>
						<span v-show="errors.has('new-password')" class="help is-danger">
							{{ errors.first("new-password") }}
						</span>
					</div>
				</div>
				<div class="form-group">
					<div class="field">
						<label for="confirm-password">Confirm Password</label>
						<input
							v-model="password.confirmPassword"
							v-validate="
								`${
									password.newPassword ? 'required|' : ''
								}confirmed:new-password`
							"
							class="form-control input-group js-input-password"
							type="password"
							id="confirm-password"
							name="confirm-password"
							data-vv-as="confirm password"
						>
						<span
							v-show="errors.has('confirm-password')"
							class="help is-danger"
						>
							{{ errors.first("confirm-password") }}
						</span>
					</div>
				</div>
			</div>
			<div class="col-xs-12 text-a-right">
				<button
					tabindex="-1"
					@click="cancelEditing()"
					:disabled="isSaving"
					class="btn btn-sm btn-round btn-white"
					type="submit"
				>
					CANCEL
				</button>

				<button
					type="button"
					@click="validateForm"
					class="btn btn-sm btn-round btn-green"
					:disabled="isSaving"
					:title="isSaving ? 'SAVING...' : 'SAVE'"
				>
					{{ isSaving ? "SAVING..." : "SAVE" }}
					<i v-if="isSaving" class="fa fa-spinner fa-spin fa-fw"/>
					<i v-else class="fa fa-long-arrow-right" aria-hidden="true"/>
				</button>
			</div>
			<div class="clearfix"/>
		</div>
		<!-- </form> -->
	</div>
</template>

<script>
import { Validator } from "vee-validate";
import { helpers, userMixin } from "../../util/mixins";
import { getUserData, setUserData } from "../../util/helpers.js";

export default {
	name: "EditUserInfo",
	mixins: [helpers, userMixin],
	data() {
		return {
			birthDate: {
				day: "",
				month: "",
				year: ""
			},
			password: {
				currentPassword: "",
				newPassword: "",
				confirmPassword: ""
			},

			id: 0,
			username: "",
			dob: "",
			email: "",
			location: "",
			photo: "",
			file: null,
			countries: nzxt.countries,
			isSaving: false
		};
	},
	computed: {
		yearList() {
			const MAX_YEAR = 105;
			const CURRENT_YEAR = new Date().getFullYear();
			const MIN_YEAR = CURRENT_YEAR - MAX_YEAR;

			const yearList = [];
			for (let year = MIN_YEAR; year <= CURRENT_YEAR; year++) {
				yearList.push(year);
			}

			return yearList.reverse();
		}
	},
	created() {
		this.setLocalData();

		this.setupValidationMessages();
		this.updateUserData();
	},
	methods: {
		setLocalData() {
			const user = getUserData();
			this.id = user.id;
			this.username = user.username;
			this.dob = user.dob;
			this.email = user.email;
			this.location = user.location;
			this.photo = user.photo;

			if (this.dob) {
				this.updateBirthDate(this.dob);
			}
		},
		setupValidationMessages() {
			const dictionary = {
				en: {
					custom: {
						username: {
							required: "Please enter in a username.",
							min: "Your Username must be at least 4 characters long.",
							max: "Your Username cannot exceed 16 characters long."
						},
						email: {
							required:
								"You must enter in your email address in order to register."
						},
						"new-password": {
							regex: () => {
								if (!this.password.newPassword) {
									return "Please enter in a password.";
								} else if (!this.password.newPassword.match(/^.{6,}$/g)) {
									return "Please enter in a password 6 characters or longer for your own security.";
								} else if (!this.password.newPassword.match(/\d/g)) {
									return "Password must include a number.";
								} else if (!this.password.newPassword.match(/(?=.*[a-z])/g)) {
									return "Password must include an lowercase letter.";
								} else if (!this.password.newPassword.match(/(?=.*[A-Z])/g)) {
									return "Password must include an uppercase letter.";
								}
							},
							required: "Please enter in the new password."
						},
						confirm_password: {
							required: "You must confirm your password!",
							confirmed: "Your passwords does not match, please try again."
						}
					}
				}
			};

			Validator.localize(dictionary);
		},
		updateUserData() {
			this.getCurrentUser()
				.then(user => {
					setUserData(user);
					if (user.dob) {
						this.updateBirthDate(user.dob);
					}
				})
				.catch(error => {});
		},
		updateBirthDate(date) {
			const formatedDate = moment(date).format("D-M-YYYY");
			if (!moment(formatedDate).isValid()) {
				return;
			}
			const [day, month, year] = moment(date)
				.format("D-M-YYYY")
				.split("-");

			this.birthDate.day = day;
			this.birthDate.month = month;
			this.birthDate.year = year;
		},
		async validateForm() {
			this.$validator.errors.remove("current-password");
			const isValid = await this.$validator.validateAll();
			if (!isValid) {
				$(`[name=${this.$validator.errors.items[0].field}]`).focus();
				this.isSaving = false;
				return;
			}
			this.save();
		},
		save() {
			this.isSaving = true;
			axios({
				url: `/users/${this.id}`,
				method: "POST",
				data: this.prepareData()
			})
				.then(response => {
					const updatedUserData = _.extend(
						getUserData(),
						this.trimObjValues(response.data)
					);
					setUserData(updatedUserData);
					localStorage.setItem("userData", JSON.stringify(updatedUserData));
					_learnq.push(["track", "Updated Account"]);
					// TODO: Change this event name for something more descritive
					// Update the userData
					window.EventBus.$emit("user-logged-in", updatedUserData);
					// Update the header userData
					this.$store.dispatch("saveUserData", updatedUserData);
					this.$emit("isEditing", false);
				})
				.catch(error => {
					if (error.response && error.response.data) {
						const errorMessage = error.response.data.status.message;
						if (errorMessage == "Wrong password") {
							this.$validator.errors.add({
								field: "current-password",
								msg: "The current password is incorrect."
							});
							$(`[name=current_password]`).focus();
						} else if (errorMessage == "Username already in use") {
							this.$validator.errors.add({
								field: "username",
								msg: errorMessage
							});
							$(`[name=username]`).focus();
						} else if (errorMessage == "Email is not available.") {
							this.$validator.errors.add({
								field: "email",
								msg: "This email is already taken by other account."
							});
							$(`[name=email]`).focus();
						}
					}
				})
				.then(() => (this.isSaving = false));
		},
		cancelEditing() {
			this.$emit("isEditing", false);
		},
		loadPhoto(photo) {
			if (photo.target.files.length) {
				this.file = photo.target.files;

				if (photo.target.files && photo.target.files[0]) {
					const reader = new FileReader();
					reader.onload = (e) => {
						$("#edit-user-photo").attr("src", e.target.result);
					};
					reader.readAsDataURL(photo.target.files[0]);
				}
			} else {
				this.file = null;
				$("#edit-user-photo").attr("src", this.photo);
			}
		},
		prepareData() {
			const formData = new FormData();
			formData.append("username", this.username);
			formData.append("email", this.email);
			formData.append("password", this.password.currentPassword);
			formData.append("new_password", this.password.newPassword);
			formData.append("confirm_password", this.password.confirmPassword);
			formData.append("year", this.birthDate.year);
			formData.append(
				"month",
				this.birthDate.month <= 9
					? "0" + this.birthDate.month.toString()
					: this.birthDate.month.toString()
			);
			formData.append(
				"day",
				this.birthDate.day <= 9
					? "0" + this.birthDate.day.toString()
					: this.birthDate.day.toString()
			);
			formData.append("country", this.location);
			if (this.file && this.file.length) {
				formData.append("photo", this.file[0]);
			}
			return formData;
		}
	}
};
</script>

<style scoped>
.profile-img {
	overflow: hidden;
}
</style>
